import './App.css';
import TopButtons from './components/TopButtons';
import UpperLogo from './components/UpperLogo';
import Inputs from './components/Inputs';
import TimeAndLocation from './components/TimeAndLocation';
import TemperatureAndDetails from './components/TemperatureAndDetails';
import Forecast from './components/Forecast';
import getFormattedWeatherData from './services/weatherService';
import { useEffect, useState } from 'react';
import UilReact from '@iconscout/react-unicons/icons/uil-react';
//importes neeeded fot app.js and it includes some functions

//app function
function App() {

  //making default so app have a default details to start
  const [query, setQuery] = useState({ q: "berlin" });
  const [units, setUnits] = useState("metric");
  const [weather, setWeather] = useState(null);

  // const fetchWeather = async () => {
  //   const data = await getFormattedWeatherData({ q: "london" });
  //   console.log(data);
  // };

  useEffect(() => {
    const fetchWeather = async () => {

        await getFormattedWeatherData({...query, units}).then((data
          ) => {
            setWeather(data);
          });

    };
    fetchWeather();
  }, [query, units]);


  const formatBackground = () => {
    if (!weather) return 'from-cyan-700 to-blue-700';
    const threshold = units == 'metric' ? 20 : 60
    if (weather.temp <= threshold) return 'from-cyan-700 to-blue-700'

    return 'from-yellow-700 to-orange-700'
  }

  return (
    <div className={`mx-auto max-w-screen-md mt-4 py-5 px-32 bg-gradient-to-br from-cyan-700 to-blue-700 h-fit shadow-xl shadow-gray-400 ${formatBackground()}`}>
     <UpperLogo />
     <TopButtons setQuery={setQuery}/>
     <Inputs setQuery={setQuery} units={units} setUnits={setUnits}/>
     
      {/* <div>
        <TimeAndLocation weather={weather} />
        <TemperatureAndDetails weather={weather} />
        <Forecast title="Hourly Forecast"/>
        <Forecast title="Daily Forecast"/>
      </div> */}

      {weather && (
        <div>
          <TimeAndLocation weather={weather} />
          <TemperatureAndDetails weather={weather} />

          <Forecast title="hourly forecast" items={weather.hourly} />
          <Forecast title="daily forecast" items={weather.daily} />
        </div>
      )}
      
      
     </div> 
  );
}

export default App;
